import React, { useRef, useState } from "react";
import { fetchJson, getApiErrorMessage, API } from "../api";
import FileZone from "./FileZone";

function FileUpload({ onUploadSuccess }) {
  const formRef = useRef(null);
  const [form, setForm] = useState({
    password: "",
    name: "",
    description: "",
  });
  const [downloadFile, setDownloadFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [uploading, setUploading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    if (!downloadFile) {
      setStatus({ type: "danger", message: "Lütfen indirilecek dosyayı seçin." });
      return;
    }

    const body = new FormData();
    body.append("password", form.password);
    body.append("name", form.name);
    body.append("description", form.description);
    body.append("downloadFile", downloadFile);
    if (imageFile) {
      body.append("imageFile", imageFile);
    }

    setUploading(true);
    try {
      const data = await fetchJson(API.upload, {
        method: "POST",
        body,
      });

      setStatus({ type: "success", message: "Yazılım başarıyla eklendi." });
      setForm({ password: "", name: "", description: "" });
      setDownloadFile(null);
      setImageFile(null);
      formRef.current?.reset();

      if (onUploadSuccess) {
        onUploadSuccess(data.software);
      }
    } catch (error) {
      setStatus({ type: "danger", message: getApiErrorMessage(error) });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="rs-admin-panel">
      <div className="rs-admin-panel__header">
        <div className="rs-admin-panel__icon">+</div>
        <div>
          <h2 className="rs-admin-panel__title">Yeni Yazılım Ekle</h2>
          <p className="rs-admin-panel__desc">
            İndirilebilir dosya ve ürün bilgilerini girin
          </p>
        </div>
      </div>
      <div className="rs-admin-panel__body">
        <form ref={formRef} onSubmit={handleSubmit}>
          <div className="rs-form-grid">
            <div className="rs-field">
              <label className="rs-label" htmlFor="password">
                Yönetici Şifresi
              </label>
              <input
                type="password"
                className="rs-input"
                id="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
              />
            </div>

            <div className="rs-field">
              <label className="rs-label" htmlFor="name">
                Yazılım Adı
              </label>
              <input
                type="text"
                className="rs-input"
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Örn. RioSat Smart IPTV"
                required
              />
            </div>

            <div className="rs-field rs-field--full">
              <label className="rs-label" htmlFor="description">
                Açıklama
              </label>
              <textarea
                className="rs-textarea"
                id="description"
                name="description"
                rows="2"
                value={form.description}
                onChange={handleChange}
                placeholder="Kısa bir açıklama yazın..."
              />
            </div>

            <FileZone
              id="downloadFile"
              label="İndirilecek Dosya"
              hint=".txt, .bin, .exe, .pdf ve diğer tüm türler — max 200 MB"
              file={downloadFile}
              onChange={setDownloadFile}
              required
            />

            <FileZone
              id="imageFile"
              label="Ürün Görseli"
              hint="İsteğe bağlı — .jpg, .png, .txt vb. tüm türler"
              file={imageFile}
              onChange={setImageFile}
            />
          </div>

          {status.message && (
            <div className={`rs-alert rs-alert--${status.type}`} role="alert">
              {status.message}
            </div>
          )}

          <div className="rs-form-actions">
            <button
              type="submit"
              className="rs-btn rs-btn-primary"
              disabled={uploading}
            >
              {uploading ? "Yükleniyor..." : "Yazılımı Yayınla"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FileUpload;
